export default "__VITE_ASSET__Dv_M_2QY__"